/**
 * ======================================================
 *            Details Page Review and Rating
 * ======================================================
*/

import {
    updateReviewRatingSummarySection,
    getUserReviewData,
    getRatingGraphData,
    showReviewRatingPopup,
    hideReviewRatingPopup,
    validateReviewRating,
    delegateRating,
    reviewImagePopup,
    inputReviewImage,
    submitReviewRating,
    showReview,
    handleExpandReview,
    submitVote } from './rating-review-module';

const PAGE_CONTEXT = $("meta[name='context-path']").attr('content'),
    LOGIN_PAGE = PAGE_CONTEXT + '/login',
    CSRF = $("meta[name='csrf-token']").attr('content'),
    PRODUCT_ID = $('#js--product-id').val(),
    REVIEW_PATH = '/productreviews/';

const applicationProperties = require('../../../applicationProperties.json'),
    IMAGE_FILE_PATH = applicationProperties.imgFilePath,
    USER_IMAGE_URL = applicationProperties.userImageUrl;

const ratings = document.getElementById('js--rating');
const formRatings = document.getElementById('js--form-rating');

let noOfRatings = +$('#js--no-of-rating').val();
let noOfReviews = +$('#js--no-of-review').val();

let rating = 0;
let reviewPageNo = 1;
let isEdit = false;
let isClosed = false;
let reviewImagesInput = [];

$('#js--rating').delegate('i', 'click', function () {
    rating = $(this).attr('data-rating');
    showReviewRatingPopup(rating, PRODUCT_ID, ratings, formRatings);
    delegateRating($(this), rating, ratings);
});

$('#js--form-rating').delegate('i', 'click', function () {
    rating = $(this).attr('data-rating');
    delegateRating($(this), rating, formRatings);
});

$('#js--btn-write-review').on('click', function() {
    isEdit = false;
    showReviewRatingPopup(rating, PRODUCT_ID, ratings, formRatings);
});

/**
 * TODO: Need to remove isEdit flag variable
 */
$('#js--btn-update-review').on('click', function() {
    isEdit = true;
    showReviewRatingPopup(rating, PRODUCT_ID, ratings, formRatings);
});

function hoverEffectRating(ratings, isForm = false) {
    if (!isForm) {
        $([...ratings.children]).on('mouseover', function () {
            $(this).addClass('ion-ios-star').removeClass('ion-ios-star-outline');
            $(this).prevAll().addClass('ion-ios-star').removeClass('ion-ios-star-outline');
        }).on('mouseleave', function () {
            $(this).removeClass('ion-ios-star').addClass('ion-ios-star-outline');
            $(this).prevAll().removeClass('ion-ios-star').addClass('ion-ios-star-outline');
        });
    }

    $([...ratings.children]).on('mouseleave', function () {
        if (rating > 0) {
            for (let i = 0; i < rating; i++) {
                $([...ratings.children][i])
                    .removeClass('ion-ios-star-outline')
                    .addClass('ion-ios-star');
            }
        }
    });
}

if (ratings) {
    hoverEffectRating(ratings);
}

if (formRatings) {
    hoverEffectRating(formRatings, true);
}

$('#js--review-writing').on('keyup', function () {
    rating = $('#js--form-rating').find('.ion-ios-star').length;
    validateReviewRating(rating, $(this));
});

$(document).on('click', '.js--review-img', function() {
    reviewImagePopup($(this), rating);
});

$('#js--review-image-viewer-close-btn').on('click', (e) => {
    $('#js--review-img-viewer-popup').hide();
    $("#js--overlay-new").hide();
});

$('#review-image-input').on('change', (e) => {
    inputReviewImage(e, reviewImagesInput);
});

$(document).on('click', '.js--review-upload-img-close', function() {
    $(this).parent('.item').remove();
    reviewImagesInput = reviewImagesInput.filter(item => item.name != $(this).parent('.item').data('name'));
    $('#js--review-image-input-count').text(reviewImagesInput.length);
    $('#review-image-input').val('');
});

$('#js--review-submit').click(function () {
    if (!$('#js--form-rating').find('.ion-ios-star').length) {
        $('.icon-star-wrapper').css('border', '1px solid red');
        $('#js--rating-error').removeClass('d-none').text('Please give the rating');
        $('#js--message-review-details').hide();
        return false;
    }

    rating = $('#js--form-rating').find('.ion-ios-star').length;

    $('.icon-star-wrapper').css('border', 'none');

    if (PRODUCT_ID && rating && CSRF) {
        const params = {
            productId: PRODUCT_ID,
            rating,
            CSRF,
            reviewImagesInput,
            ratings,
            formRatings,
            noOfRatings,
            noOfReviews,
            reviewPath: REVIEW_PATH,
            userImageUrl: USER_IMAGE_URL,
            imageFilePath: IMAGE_FILE_PATH
        }
        submitReviewRating(params);
    }
});

$('#js--btn-close-review-rating-popup, #js--overlay-new').on('click', () => {
    hideReviewRatingPopup(ratings, rating, formRatings, isEdit);
    rating = 0;
    $("#js--review-img-viewer-popup").fadeOut();
});

$(document).ready(function () {
    if ($('#js--current-path').val() === 'details') {
        if (document.querySelector('meta[name=user-id]')) {
            getUserReviewData(rating, PRODUCT_ID, ratings, formRatings);
        }
        getRatingGraphData(PRODUCT_ID);
    }
});

if ($('#js--current-path').val() === 'details') {
    showReview(`${PAGE_CONTEXT}${REVIEW_PATH}${PRODUCT_ID}/`, reviewPageNo, USER_IMAGE_URL, IMAGE_FILE_PATH);
}

$(document).on('click', '.js--review-read-expand', (e) => {
    handleExpandReview(e);
});

$('#js--show-more-reviews').click(function (e) {
    e.preventDefault();
    reviewPageNo++;
    const filterValue = $('#js--filter-review').data('enum');
    showReview(`${PAGE_CONTEXT}${REVIEW_PATH}${PRODUCT_ID}/`, reviewPageNo, USER_IMAGE_URL, IMAGE_FILE_PATH, filterValue);
});

$(document).on('click', '.js--vote', function (e) {
    e.preventDefault();
    submitVote($(this).attr('review-id'), $(this).attr('data-value'), LOGIN_PAGE, CSRF);
});

$('.js--filter-review-option').on('click', function() {
    const filterEnum = $(this).data('enum');
    const filterValue = $(this).data('value');
    showReview(`${PAGE_CONTEXT}${REVIEW_PATH}${PRODUCT_ID}/`, reviewPageNo, USER_IMAGE_URL, IMAGE_FILE_PATH, filterEnum);
    $('#js--filter-review').attr('data-enum', filterEnum)
    $('#js--filter-review').text(filterValue)
});
